import { reduxType } from "../../interfaces/reducerType"
const defaultState: any = {
    isVisible: false,
    tags: []
};
function reducer(state = defaultState, {type, payload }: reduxType) {
    switch (type) {
        case "setDrawer":
            return payload
        default:
            return state;    
    }
}
export default reducer;